import { GridInputValue } from '../../../../types/types';

export const parseNumberValue = (value: GridInputValue): number | null => {
  if (typeof value === 'number') return value;
  if (typeof value !== 'string' || value === '') return null;
  const parsed = Number(value);
  return Number.isNaN(parsed) ? null : parsed;
};
